import styled from 'styled-components';

import { Title } from '@atom/typography/typography';

export const Wrapper = styled.div`
  padding: 0 8px;
`;

export const SubTitleWrapper = styled.div`
  display: flex;
  padding: 0 0 20px;
  justify-content: center;
`;

export const SubTitle = styled(Title).attrs({
  level: 3,
  weight: 400,
})`
  flex: 1;
`;

export const ConsumerStatsWrapper = styled.div`
  margin-top: 24px;
`;
